import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WindowsOutlinedSvg from "@ant-design/icons-svg/es/asn/WindowsOutlined";
import AntdIcon from '../components/AntdIcon';
var WindowsOutlined = function WindowsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: WindowsOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(WindowsOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'WindowsOutlined';
}
export default RefIcon;